export default __webpack_public_path__ + "static/media/honey_land.73f06451.png";